export default "__VITE_ASSET__X7ZFyzUO__"